/**
 * 매체들이 공통으로 사용할 메소드 정의
 * 이 클래스를 상속받아서 각 매체들의 브릿지를 생성하며 메소드들을 오버라이드 해서 사용한다.
 */
class BaseBridge {
  protected isIos: boolean;
  protected osType: string;

  constructor(osType: string) {
    this.osType = osType;
    this.isIos = osType === 'IOS';
    if (!window) return;
    if (this.isIos && !window.webkit?.messageHandlers?.tauthJs) return;
    if (!this.isIos && !window.tauthJs) return;
  }

  /**
   * 내장 브라우저로 새창열기
   */
  OPEN_OUT_LINK() {
    console.log('=== [ Bridges ] open out link');
  }

  /**
   * 내부 웹뷰 띄우기
   */
  OPEN_WEB_VIEW() {
    console.log('=== [ Bridges ] open web view');
  }

  /**
   * 웹뷰 창 닫기
   */
  CLOSE() {
    console.log('=== [ Bridges ] web view close');
  }
}

export default BaseBridge;
